module.exports = __webpack_public_path__ + "img/229.557a393a.jpg";